import Vue from 'vue';
import App from './App.vue';
import _ from 'underscore';
import AsyncComputed from 'vue-async-computed';

window._ = _;
Vue.use(AsyncComputed);
new Vue({
  el: '#locations',
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js